import { push } from 'react-router-redux';
import { stringify as qsStringify } from 'querystring';

import { AuthConfig } from './../../conf/config';
import {messagesDictionary} from './../../conf/messagesDictionary';

import firebaseApp from './../../utils/firebase/firebase';
import SingletonLibrary from '../../library/SingletonLibrary';

import * as types from './authActionTypes';

import * as userActions from './../user/userActions';
import { destroyHistoryListeners } from './../History/historyActions';
import { destroyPointsListeners } from './../Points/pointsActions';
import { setupInit } from './../SetupLoader/setupLoaderActions';

//export for test
export const loginSuccess = (uid) => {
    return {
        type: types.LOGIN_SUCCESS,
        uid
    }
}

export const loginError = (errorMessage, errorCode) => {
     // translate errorMessage in French when message is returned from Firebase (based on Error Code)
     if(errorCode!=='' && typeof messagesDictionary['FIREBASE_ERROR_CODE'].hasOwnProperty('login-'+errorCode)){
        errorMessage = messagesDictionary['FIREBASE_ERROR_CODE']['login-'+errorCode];
    }

    return {
        type: types.LOGIN_ERROR,
        errorMessage,
        errorCode
    }
}

export function login(username, password) {

    const email = username.trim().toLowerCase().replace(/ /g, '_') + '@kidsmatin.com';
    return (dispatch) => {
        return firebaseApp.auth().signInWithEmailAndPassword(email, password)
            .then(function(){
                const userId = firebaseApp.auth().currentUser.uid;
                const expirationDate = new Date(new Date().getTime() + AuthConfig.expiresIn * 60 * 1000);    
                // const userName = firebaseApp.auth().currentUser.email; 

                // use localStorage
                localStorage.setItem('expirationDate', expirationDate);    

                // We dispatch in the meantime (other things are loading behind through XHR calls) to loading page
                dispatch(push('/loading'));
                dispatch(setupInit());

                dispatch( loginSuccess(userId) );
                dispatch( userActions.getCurrentUser(userId) );

                // Update routing for subscribers
                dispatch(checkSubscriptionStatus(true));
               
            })
            .catch((error) => {
                dispatch(loginError(error.message, error.code));
            });
    };
}


export const checkSubscriptionStatusSuccess = ( isSubscriber ) => {
    return {
        type: types.RETRIEVE_SUBSCRIPTION_SUCCESS,
        isSubscriber
    }
}

export const checkSubscriptionStatusStart = () => {
    return {
        type: types.RETRIEVE_SUBSCRIPTION_START,
    }
}

export function checkSubscriptionStatus(redirect) {
    
    return (dispatch, getState) => {

        firebaseApp.auth().currentUser.getIdToken()
            .then(function(fbIdToken) {
                   
                dispatch(checkSubscriptionStatusStart()); 
        
                SingletonLibrary
                    .getAxiosInstance
                    .get('/account/check-subscribe', { headers:{'fbkm-access-token':fbIdToken}})
                    .then((result) => {
                      
                        let isSubscriber = (typeof result.data !== 'undefined' && typeof result.data.response !== 'undefined')? result.data.response : false;

                        var updates = {};
                        updates[`users/${ firebaseApp.auth().currentUser.uid }/lastTimeLoggedIn`] = new Date();
            
                        firebaseApp.database().ref()
                            .update(updates);

                        dispatch(checkSubscriptionStatusSuccess(isSubscriber));
                        
                        if(redirect)
                        {
                            dispatch(push('/'));
                        }
                        
                        
                    })
                    .catch((e) => {
                        const errorCode =  ( typeof e.response !== 'undefined' && e.response.status ) || 0;
                        const errorMessage = ( typeof e.response !== 'undefined' && e.response.statusText ) || 'Erreur inattendue';

                        var updates = {};
                        updates[`users/${ firebaseApp.auth().currentUser.uid }/lastTimeLoggedIn`] = new Date();
            
                        firebaseApp.database().ref()
                            .update(updates);

                        dispatch(checkSubscriptionStatusSuccess(false));
                        
                        dispatch(loginError(errorMessage, errorCode));
                         
                        if(redirect)
                        {
                            dispatch(push('/'));
                        }
                    });
            });
    }
}

const logoutInSuccess = () => {
    return {
        type: types.LOGOUT_SUCCESS,
    }
} 
  
const logoutInError = (errorMessage) => {
    return {
        type: types.LOGOUT_ERROR,
        errorMessage
    }
}

export const logout = () => {
    return (dispatch, getState) => {
        
        const userId = getState().auth.uid;
        
        // when user is not signed in, by default, uid = 0
        if(userId !== 0){
            // we remove all binded user listener(s) related to History Component 
            dispatch(destroyHistoryListeners(firebaseApp.auth().currentUser.uid));
            dispatch(destroyPointsListeners(firebaseApp.auth().currentUser.uid))
            firebaseApp.database().ref(`users/${ firebaseApp.auth().currentUser.uid }`).off();
        }

        firebaseApp.auth().signOut()
            .then(function () {       
                
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('state');
       
                dispatch(
                    logoutInSuccess()
                );
            })
            .catch((error) => {
                dispatch(logoutInError(error.message))
            });
    }
}

export const removeError = () => {
    return {
        type: types.REMOVE_ERROR
    }
}

export const error = (errorMessage) => {
  return {
      type: types.ERROR,
      errorMessage
  }
}




// WEBPACK FOOTER //
// ./src/components/Auth/authActions.js